var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1228,
    height: 50,
    viewBox: "0 0 1228 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1146.55 -0.474323C1146.67 -0.945885 1147.32 -0.993663 1147.5 -0.543899L1150.62 7.13771C1150.7 7.33877 1150.9 7.46428 1151.12 7.44842L1159.34 6.84552C1159.83 6.81017 1160.07 7.41185 1159.7 7.72509L1153.4 13.0842C1153.24 13.2239 1153.18 13.4532 1153.26 13.653L1156.38 21.3438C1156.56 21.7929 1156.06 22.2125 1155.65 21.9558L1148.65 17.5815C1148.47 17.4661 1148.23 17.4836 1148.06 17.6246L1141.77 22.9734C1141.4 23.2874 1140.85 22.945 1140.96 22.4741L1142.93 14.4107C1142.98 14.2011 1142.89 13.9825 1142.71 13.8682L1135.69 9.4855C1135.28 9.22933 1135.44 8.59812 1135.92 8.56277L1144.14 7.95986C1144.36 7.944 1144.54 7.79039 1144.59 7.57958L1146.55 -0.474323Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.55 34.5257C1211.67 34.0541 1212.32 34.0063 1212.5 34.4561L1215.62 42.1377C1215.7 42.3388 1215.9 42.4643 1216.12 42.4484L1224.34 41.8455C1224.83 41.8102 1225.07 42.4119 1224.7 42.7251L1218.4 48.0842C1218.24 48.2239 1218.18 48.4532 1218.26 48.653L1221.38 56.3438C1221.56 56.7929 1221.06 57.2125 1220.65 56.9558L1213.65 52.5815C1213.47 52.4661 1213.23 52.4836 1213.06 52.6246L1206.77 57.9734C1206.4 58.2874 1205.85 57.945 1205.96 57.4741L1207.93 49.4107C1207.98 49.2011 1207.89 48.9825 1207.71 48.8682L1200.69 44.4855C1200.28 44.2293 1200.44 43.5981 1200.92 43.5628L1209.14 42.9599C1209.36 42.944 1209.54 42.7904 1209.59 42.5796L1211.55 34.5257Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.554 -15.4743C50.6689 -15.9459 51.3207 -15.9937 51.5031 -15.5439L54.6192 -7.86229C54.7008 -7.66123 54.9027 -7.53572 55.1191 -7.55158L63.3437 -8.15448C63.8259 -8.18983 64.0725 -7.58815 63.7041 -7.27491L57.4016 -1.91583C57.2373 -1.77612 57.1811 -1.54681 57.2622 -1.34696L60.382 6.34375C60.5642 6.79288 60.0649 7.21254 59.6538 6.95578L52.6507 2.58148C52.466 2.4661 52.2278 2.48356 52.0619 2.62464L45.7716 7.97342C45.4023 8.28738 44.8471 7.94502 44.9619 7.47413L46.9268 -0.589323C46.9779 -0.798858 46.8888 -1.01752 46.7059 -1.13177L39.6893 -5.5145C39.2792 -5.77067 39.4354 -6.40188 39.9176 -6.43723L48.1422 -7.04014C48.3586 -7.056 48.5401 -7.20961 48.5914 -7.42042L50.554 -15.4743Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.554 28.5257C106.669 28.0541 107.321 28.0063 107.503 28.4561L110.619 36.1377C110.701 36.3388 110.903 36.4643 111.119 36.4484L119.344 35.8455C119.826 35.8102 120.072 36.4119 119.704 36.7251L113.402 42.0842C113.237 42.2239 113.181 42.4532 113.262 42.653L116.382 50.3438C116.564 50.7929 116.065 51.2125 115.654 50.9558L108.651 46.5815C108.466 46.4661 108.228 46.4836 108.062 46.6246L101.772 51.9734C101.402 52.2874 100.847 51.945 100.962 51.4741L102.927 43.4107C102.978 43.2011 102.889 42.9825 102.706 42.8682L95.6893 38.4855C95.2792 38.2293 95.4354 37.5981 95.9176 37.5628L104.142 36.9599C104.359 36.944 104.54 36.7904 104.591 36.5796L106.554 28.5257Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0308 14.2673C10.1457 13.7958 10.7975 13.748 10.9799 14.1978L13.1253 19.4865C13.2069 19.6876 13.4088 19.8131 13.6252 19.7972L19.29 19.382C19.7722 19.3466 20.0188 19.9483 19.6504 20.2616L15.3078 23.9541C15.1435 24.0938 15.0873 24.3232 15.1684 24.523L17.3175 29.8209C17.4997 30.27 17.0004 30.6897 16.5893 30.4329L11.7681 27.4215C11.5834 27.3061 11.3453 27.3236 11.1794 27.4646L6.84888 31.1469C6.47964 31.4609 5.92445 31.1185 6.0392 30.6476L7.39277 25.093C7.44383 24.8835 7.35478 24.6648 7.17187 24.5505L2.33721 21.5307C1.92709 21.2745 2.08328 20.6433 2.56554 20.608L8.23032 20.1927C8.44671 20.1769 8.62818 20.0232 8.67955 19.8124L10.0308 14.2673Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1147.34,
    y1: -0.759081,
    x2: 1149.58,
    y2: 20.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC72E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1212.34,
    y1: 34.2409,
    x2: 1214.58,
    y2: 55.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC72E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 51.3414,
    y1: -15.7591,
    x2: 53.5823,
    y2: 5.75304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC72E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 107.341,
    y1: 28.2409,
    x2: 109.582,
    y2: 49.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC72E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 10.7117,
    y1: 13.6737,
    x2: 12.3854,
    y2: 29.7413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC72E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponStars);
export default __webpack_public_path__ + "static/media/coupon_stars.2b4553b7601cd69ebc3ca0efabe22a54.svg";
export { ForwardRef as ReactComponent };